"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstructorSearchService = void 0;
const transformConstructorFacetsToFilters_1 = require("./transformConstructorFacetsToFilters");
const transformConstructorSearchResults_1 = require("./transformConstructorSearchResults");
const helpers_1 = require("../../helpers");
const constructorGet_1 = require("../../constructorGet");
const transformConstructorAutocompleteResults_1 = require("./transformConstructorAutocompleteResults");
class ConstructorSearchService {
    constructor(params) {
        this.userId = params.userId || '';
    }
    fetchSearchProviderData(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = '', filters = {}, predefinedFilters = {}, sort = '', page = 1, resultsPerPage = 100, destinationZone = 'US', selectedCategory, isServerSide, isPrintsPage, userSizePreference, shouldAddGroupIdFilter, defaultSortObject, getContentRule, filterByIds, }) {
            var _b, _c, _d;
            try {
                // remove query, hitsPerPage and page from the filters sent
                const filtersWithoutBasicQueryParams = (0, helpers_1.rulesToSendFilters)({
                    filters,
                    destinationZone,
                    isPrintsPage,
                    userSizePreference,
                    shouldAddGroupIdFilter,
                });
                const finalFiltersToSearchProvider = Object.assign(Object.assign({}, predefinedFilters), filtersWithoutBasicQueryParams);
                const { sortBy, sortOrder } = (0, helpers_1.getSortValues)({ sort, destinationZone });
                const response = yield (0, constructorGet_1.constructorGetData)({
                    query,
                    filters: finalFiltersToSearchProvider,
                    sortBy: Boolean(sortBy) ? sortBy : defaultSortObject === null || defaultSortObject === void 0 ? void 0 : defaultSortObject.sortBy,
                    sortOrder: Boolean(sortOrder) ? sortOrder : defaultSortObject === null || defaultSortObject === void 0 ? void 0 : defaultSortObject.sortOrder,
                    page,
                    resultsPerPage,
                    selectedCategory: isPrintsPage ? 'prints' : selectedCategory,
                    isServerSide,
                    userId: this.userId,
                    filterByIds,
                });
                if (response.type === 'redirect') {
                    return {
                        success: true,
                        payload: {
                            data: {
                                type: 'redirect',
                                redirectLink: ((_c = (_b = response.redirect) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.url) || '',
                                matechedTerms: ((_d = response.redirect) === null || _d === void 0 ? void 0 : _d.matched_terms) || [],
                            },
                        },
                    };
                }
                const transformedResults = (0, transformConstructorSearchResults_1.transformConstructorSearchResults)({
                    searchRequest: response.request,
                    searchResults: response.results,
                    destinationZone,
                });
                const transformedContentRule = getContentRule
                    ? (0, transformConstructorSearchResults_1.transformConstructorContentRule)({
                        constructorResponse: response.response,
                    })
                    : [];
                const mergedResults = (0, transformConstructorSearchResults_1.mergeContentRulesIntoResults)(transformedResults, transformedContentRule);
                const transformedFacets = (0, transformConstructorFacetsToFilters_1.transformConstructorFacetsToFilters)(response.facets);
                return {
                    success: true,
                    payload: {
                        data: {
                            type: 'products',
                            results: mergedResults,
                            facets: transformedFacets,
                            totalResults: response.totalResults,
                        },
                    },
                };
            }
            catch (error) {
                console.error('Error fetching search results from Constructor.io:', error);
                return {
                    success: false,
                    payload: { message: 'Error fetching search results from Constructor.io' },
                };
            }
        });
    }
    fetchSearchProviderFacets(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = '', filters = {}, predefinedFilters = {}, sort = '', page = 1, resultsPerPage = 100, destinationZone = 'US', selectedCategory, isServerSide, isPrintsPage, userSizePreference, shouldAddGroupIdFilter, defaultSortObject, }) {
            try {
                // remove query, hitsPerPage and page from the filters sent
                const filtersWithoutBasicQueryParams = (0, helpers_1.rulesToSendFilters)({
                    filters,
                    destinationZone,
                    isPrintsPage,
                    userSizePreference,
                    shouldAddGroupIdFilter,
                });
                const finalFiltersToSearchProvider = Object.assign(Object.assign({}, predefinedFilters), filtersWithoutBasicQueryParams);
                const { sortBy, sortOrder } = (0, helpers_1.getSortValues)({ sort, destinationZone });
                const facetData = yield (0, constructorGet_1.constructorGetFacets)({
                    query,
                    filters: finalFiltersToSearchProvider,
                    sortBy: Boolean(sortBy) ? sortBy : defaultSortObject === null || defaultSortObject === void 0 ? void 0 : defaultSortObject.sortBy,
                    sortOrder: Boolean(sortOrder) ? sortOrder : defaultSortObject === null || defaultSortObject === void 0 ? void 0 : defaultSortObject.sortOrder,
                    page,
                    resultsPerPage,
                    selectedCategory: isPrintsPage ? 'prints' : selectedCategory,
                    isServerSide,
                    userId: this.userId,
                });
                const facetFromConstructor = Array.isArray(facetData) ? facetData : [];
                const transformedFacets = (0, transformConstructorFacetsToFilters_1.transformConstructorFacetsToFilters)(facetFromConstructor);
                return { success: true, payload: { data: transformedFacets } };
            }
            catch (error) {
                console.error('Error fetching facets from Constructor.io:', error);
                return {
                    success: false,
                    payload: { message: 'Error fetching facets from Constructor.io' },
                };
            }
        });
    }
    fetchSearchProviderAutocomplete(_a) {
        return __awaiter(this, arguments, void 0, function* ({ query = '', filters = {}, numResults, shouldLowerCaseText, isServerSide, }) {
            var _b;
            try {
                const onlySpaces = ((_b = query === null || query === void 0 ? void 0 : query.trim()) === null || _b === void 0 ? void 0 : _b.length) === 0;
                if (onlySpaces) {
                    return {
                        success: true,
                        payload: {
                            data: {
                                matchedTerm: '',
                                autocompleteSuggestions: [],
                                totalResults: 0,
                            },
                        },
                    };
                }
                const { request, sections, totalResultsPerSection } = yield (0, constructorGet_1.constructorGetAutocomplete)({
                    query,
                    numResults,
                    filters,
                    isServerSide,
                    userId: this.userId,
                });
                const autocompleteResults = (0, transformConstructorAutocompleteResults_1.transformConstructorAutocompleteResults)(sections, shouldLowerCaseText);
                return {
                    success: true,
                    payload: {
                        data: {
                            matchedTerm: (request === null || request === void 0 ? void 0 : request.term) || '',
                            autocompleteSuggestions: autocompleteResults,
                            totalResults: totalResultsPerSection.Products,
                        },
                    },
                };
            }
            catch (error) {
                console.error('Error fetching autocomplete results from Constructor.io:', error);
                return {
                    success: false,
                    payload: { message: 'Error fetching autocomplete results from Constructor.io' },
                };
            }
        });
    }
    fetchSearchProviderRecommendations(_a) {
        return __awaiter(this, arguments, void 0, function* ({ podId = '', filters = {}, numResults, section, isServerSide, itemIds, }) {
            try {
                const { response, totalResults, resultId } = yield (0, constructorGet_1.constructorGetRecommendations)({
                    podId,
                    filters,
                    numResults,
                    section,
                    isServerSide,
                    userId: this.userId,
                    itemIds,
                });
                return {
                    success: true,
                    payload: {
                        data: {
                            recommendations: (response === null || response === void 0 ? void 0 : response.results) || [],
                            totalResults,
                            resultId,
                        },
                    },
                };
            }
            catch (error) {
                console.error('Error fetching recommendations from Constructor.io:', error);
                return {
                    success: false,
                    payload: { message: 'Error fetching recommendations from Constructor.io' },
                };
            }
        });
    }
}
exports.ConstructorSearchService = ConstructorSearchService;
